module.exports = __webpack_public_path__ + "img/ch61.fe4e2be1.jpg";